import { Paginator } from "~/@shared/api-types/Paginator"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { RecruitmentStatus } from "../_common/types-for-recruitment"
import { LongInternship } from "./_types"

const PATH = "/long-internships"

export type GetLongInternships = Paginator<LongInternship>

export const fetchGetLongInternships = defineFetcher((): Promise<GetLongInternships> => {
  return GET(PATH)
})
